export default __webpack_public_path__ + "static/media/gg1.24942349.jpg";